import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import { Table, message, Icon, Button, Spin, Modal } from 'antd';
import request from 'request'
import Loading from 'ui-loading';
import Err from 'ui-error';
import DailyFeeList from './dailyFeeList'
import styles from './style.scss?__local';

const defaultPageSize = process.env.HUYA_APP_ENV === 'production' ? 20 : 2 // 测环境数据太少了，为了弄出分页

function MonthlyFeeList() {
  const [pageNum, setPageNum] = useState(1)
  const res = useRemoteData(pageNum)
  const [extFee, setExtFee] = useState(null)

  const col = {
    extName: 'extName',
    serviceFeeType: 'serviceFeeType',
    userUseData: 'userUseData',
    totalServiceFee: 'totalServiceFee',
    maxServiceFee: 'maxServiceFee',
    serviceFeeDetail: 'serviceFeeDetail',
  }

  const columns = [
    {
      title: '小程序',
      dataIndex: col.extName,
    },
    {
      title: '服务费计费维度',
      dataIndex: col.serviceFeeType,
    },
    {
      title: '本月使用计数',
      dataIndex: col.userUseData,
    },
    {
      title: '本月累计费用',
      dataIndex: col.totalServiceFee,
    },
    {
      title: '本月费用上限',
      dataIndex: col.maxServiceFee,
    },
    {
      title: '操作',
      dataIndex: col.serviceFeeDetail,
    },
  ]

  const dataSource = res && res.data ? makeDataSource(col, res.data, (action, ext) => setExtFee(ext)) : []

  let pagination = false

  if (res && res.data && res.data.total > defaultPageSize) {
    pagination = {
      onChange: pageNum => setPageNum(pageNum),
      total: res.data.total,
      defaultPageSize,
      pageSize: defaultPageSize,
      current: pageNum,
    }
  }

  let loading = false

  if (res == null) {
    loading = true
  } else if (res.data) {
    loading = false
  } else {
    loading = {
      indicator: <Err err={`获取数据失败：${res.err}`} />,
    }
  }

  return (
    <>
      <Table {...{ columns, dataSource, pagination, loading }} />
      {extFee && (
        <Modal
          visible={true}
          title={`${extFee.name}-费用明细`}
          width={750}
          destroyOnClose={true}
          onCancel={() => setExtFee(null)}
          footer={null}
        >
          <DailyFeeList {...extFee} />
        </Modal>
      )}
    </>
  )
}

function useRemoteData(page) {
  let [res, setRes] = useState(null)

  useEffect(() => {
    setRes(null)

    request({
      url: request.api.anchorExpenseSummary,
      type: 'GET',
      data: {
        page,
        pageSize: defaultPageSize,
      },
    })
      .done(data => setRes({data}))
      .fail(err => setRes({err}))

    return () => {
      setRes = () => {}
    }
  }, [page])

  return res
}

function makeDataSource(col, {serviceFeeTypes, serviceFeeList}, onAction) {
  return (serviceFeeList || []).map((item, index) => {
    const sft = getSFT(item.serviceFeeType.type, serviceFeeTypes)

    // 如果计费类型是使用时长 需要把秒转换成分钟
    const isUseTimeType = item.serviceFeeType.type == 1;

    return {
      key: index,
      [col.extName]: item.extInfo.name,
      [col.serviceFeeType]: sft.name,
      [col.userUseData]: `${isUseTimeType ? parseInt(item.userUseData / 60) : item.userUseData} ${sft.unit}`,
      [col.totalServiceFee]: `${item.totalServiceFee <= sft.maxServiceFee ? item.totalServiceFee : sft.maxServiceFee} 虎牙币`,
      [col.maxServiceFee]: `${sft.maxServiceFee} 虎牙币`,
      [col.serviceFeeDetail]: (
        <Button
          size="small"
          onClick={() => {
            onAction('view', {
              ...item.extInfo,
              serviceFeeType: sft,
            })
          }}
        >
                    查看详情
        </Button>
      ),
    }
  })
}

function getSFT(type, serviceFeeTypes) {
  return (serviceFeeTypes || []).find(item => item.type == type) || {
    type: -1,
    name: '维度',
    unit: '单位',
  }
}

export default MonthlyFeeList;
